import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectSiteComponent } from './select-site.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [SelectSiteComponent],
  imports: [CommonModule, TranslateModule],
  exports: [SelectSiteComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class SelectSiteModule {}
